export default {
  deleteConfirm: 'Naozaj si prajete zmazať túto službu?',
  registrationSuccessHeader: 'Registrácia prebehla úspešne',
  registrationSuccessContent: 'Teraz sa môžete prihlásiť. Do Vašej emailovej schránky bol odoslaný overovací email. Bez overenia svojej emailovej adresy nebudete mať prístup k niektorým funkciám.',
  switchTooltip: 'Kliknite sem pre výber spoločnosti/služby alebo pridanie služby'
}



// WEBPACK FOOTER //
// ./src/i18n/sk/messages.js